/**
 * Format date from YYYY-MM-DD to DD/MM/YYYY (UK format)
 * @param {string} dateStr - Date in YYYY-MM-DD format
 * @returns {string} Date in DD/MM/YYYY format
 */
export const formatDateUK = (dateStr) => {
  if (!dateStr) return '';
  
  // Handle both YYYY-MM-DD and ISO timestamp formats
  const date = new Date(dateStr);
  
  // Check if date is valid
  if (isNaN(date.getTime())) return dateStr;
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}/${month}/${year}`;
};

/**
 * Format date to YYYY-MM-DD for input fields
 * @param {string} dateStr - Date in any format
 * @returns {string} Date in YYYY-MM-DD format
 */
export const formatDateForInput = (dateStr) => {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

/**
 * Format datetime to UK format with time
 * @param {string} dateStr - Date string or ISO timestamp
 * @returns {string} Date in DD/MM/YYYY HH:MM format
 */
export const formatDateTimeUK = (dateStr) => {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

/**
 * Get today's date as YYYY-MM-DD string in local timezone.
 * Avoids UTC conversion issues with toISOString() that cause
 * "future date" errors in BST/CET and other UTC+ timezones.
 */
export const getLocalTodayStr = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Parse YYYY-MM-DD string as local date (not UTC).
 * new Date("2026-04-03") parses as UTC midnight which breaks
 * comparisons with local dates in UTC+ timezones.
 */
export const parseLocalDate = (dateStr) => {
  if (!dateStr) return new Date(NaN);
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
};
